export const vaciarCupon = async ({
    dispatch,
    setDescuentoTotal,
    setDescuento,
    addResultadosPromos,
    setCupon,
    setPromoMeses,
    updateDomainPromo,
    promoMeses,
    resumenData,
  }) => {
    dispatch(setDescuentoTotal(0));
    dispatch(setDescuento(""));
    dispatch(addResultadosPromos([]));
    dispatch(setCupon(''));
    if (promoMeses) {
      resumenData.forEach(resumen => {
        if (resumen.product.domain_section[0]?.promo) {
          dispatch(updateDomainPromo({ id: resumen.id, newPromo: null }));
          dispatch(setPromoMeses(false));
        }
      });
    }
};